import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Avatar, Menu, Dropdown, Modal, message, Popover, Button, Badge, Alert, Typography } from 'antd';
import Notifications from '@/components/Notification';

import {
  AppstoreOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  DeleteOutlined,
  AuditOutlined,
  BellTwoTone,
  ExclamationCircleOutlined,
  CompassTwoTone,
  CompassOutlined,
} from '@ant-design/icons';
import photo from '@/style/images/photo.png';
import { checkImage } from '@/request';

import { selectCurrentAdmin } from '@/redux/auth/selectors';
import history from '@/utils/history';
import axios from 'axios';
import uniqueId from '@/utils/uinqueId';

import { API_BASE_URL } from '@/config/serverApiConfig';
import { logout } from '@/redux/auth/actions';
// import InterviewNotifications from '@/pages/InterviewNotifications';
import NotificationComponent from '@/pages/InterviewNotifications';
import AnnouncementBanner from '@/components/anncoument/AnnoucmentBanner';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const { confirm } = Modal;

export default function HeaderContent() {
  const dispatch = useDispatch();
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const [isPopUpForNot, setIsPopUpForNot] = useState(false);
  const [hasFetched, setHasFetched] = useState(false)
  const currentAdmin = useSelector(selectCurrentAdmin);
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const showLogoutModal = () => {
    confirm({
      title: 'Are you sure you want to log out? ',
      icon: <LogoutOutlined />,
      content: 'Your session will be securely closed.',
      centered: true,

      onOk() {
        const audio = new Audio('/wrong-answer-129254.mp3');
        audio.play();
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            // Dispatch the logout action
            dispatch(logout());
            resolve();
          }, 1000);
        })
          .then(() => {
            message.success('Logout successful!');
          })
          .catch(() => {
            message.error('Logout failed!');
          });
      },
      onCancel() {
        // Handle the "Cancel" button click
      },
    });
  };


  const showPasswordResetConfirm = () => {
    confirm({
      title: "Reset Your Password",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>A password reset link will be sent to your registered email address:</p>
          <Typography.Text strong style={{ color: '#1890ff' }}>
            {currentAdmin.email}
          </Typography.Text>
          <p style={{ marginTop: 16 }}>
            The reset link will expire in 2 minutes for security reasons.
          </p>
          <Alert
            message="Important"
            description="Please check your email inbox (and spam folder) after clicking OK."
            type="info"
            showIcon
            style={{ marginTop: 16 }}
          />
        </div>
      ),
      okText: "Send Reset Link",
      cancelText: "Cancel",
      onOk: handlePasswordReset,
      width: 520,
    });
  };

  const handlePasswordReset = async () => {
    try {
      setResetLoading(true);
      // Using your existing generatePasswordReset endpoint
      await axios.post("/auth/generate-reset", {
        employeeId: null,
        userId: currentAdmin?._id,
        
      });
      message.success("Password reset link has been sent to your email!");
    } catch (error) {
      console.error("Error sending reset email:", error);
      message.error(error.response?.data?.message || "Failed to send reset email");
    } finally {
      setResetLoading(false);
    }
  };


  const srcImgProfile = checkImage(API_BASE_URL + currentAdmin?.photo)
    ? API_BASE_URL + currentAdmin?.photo
    : photo;

  const profileDropdown = (
    <div className="profileDropdown whiteBox shadow" style={{ minWidth: '200px' }}>
      <div className="pad15" onClick={() => history.push('/admin')} style={{ cursor: 'pointer' }}>
        <Avatar
          size="large"
          className="last"
          src={srcImgProfile}
          style={{ color: '#eef2f4', backgroundColor: '#1c99f5' }}
        >
          {currentAdmin?.name.toUpperCase()}
        </Avatar>
        <div className="info">
          <p className="strong">
            {currentAdmin?.name} {currentAdmin?.surname}
          </p>
          <p>{currentAdmin?.email}</p>
        </div>
      </div>

      <div>
        <Menu>
          {/* <Menu.Item
            icon={<SettingOutlined />}
            key={`${uniqueId()}`}
            onClick={() => history.push('/admin')}
          >
            Registered Users
          </Menu.Item> */}
          {/* <Menu.Item
            icon={<SettingOutlined />}
            key={`${uniqueId()}`}
            onClick={() => history.push('/settings/')}
          >
            App Settings
          </Menu.Item> */}
        </Menu>
      </div>

      <div>
        {/* <Menu>
          <Menu.Item icon={<AuditOutlined />} onClick={() => history.push('/activity-scorecard')}>
            {' '}
            View Scorecard
          </Menu.Item>
        </Menu> */}
      </div>
      <div>
        <Menu>
          <Menu.Item icon={<UserOutlined />} key={`${uniqueId()}`}>
            <Link to={'/my-profile'}>My Profile</Link>
          </Menu.Item>
          <Menu.Item
            icon={<CompassOutlined />}
            key={uniqueId()}
            onClick={() => {
              showPasswordResetConfirm()
            }}
          >
            Reset Password
          </Menu.Item>
          <Menu.Item icon={<LogoutOutlined />} key={`${uniqueId()}`} onClick={showLogoutModal}>
            Logout
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  const fetchNotifications = async (showSuccessMsg = false) => {
    setIsNotificationLoading(true);
    try {
      const { data } = await axios.get('/notifications');
      if (data.success) {
        setNotifications(data?.notifications || []);
        setUnreadCount(data.unreadCount || 0);
        setHasFetched(true);
        if (showSuccessMsg) {
          notifications.success({
            message: 'Notifications refreshed',
            description: `You have ${data.unreadCount} unread notification(s)`,
            duration: 20
          });
        }
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      message.error({
        message: 'Failed to load notifications',
        description: error.response?.data?.message || error.message,
        duration: 3
      });
    } finally {
      setIsNotificationLoading(false);
    }
  };

  // 🔥 Load notifications on page load
  useEffect(() => {
    let timeoutId;
    setHasFetched(true)
    const pollNotifications = async () => {
      try {
        await fetchNotifications(); // wait until it finishes
      } catch (err) {
        console.error('Error fetching notifications:', err);
      } finally {
        // schedule next fetch after 5 seconds
        timeoutId = setTimeout(pollNotifications, 5000);
      }
    };

    pollNotifications(); // first call immediately

    // cleanup on unmount
    return () => clearTimeout(timeoutId);
  }, []);
  function handleNotificaitons(params) {
    // setIsPopUpForNot(!isPopUpForNot)
  }
  return (
    <div
      className="headerIcon"
    // style={{ position: 'absolute', right: 0, zIndex: '99', cursor: 'pointer' }}
    >
      <Dropdown overlay={profileDropdown} trigger={['click']} placement="bottomRight">
        {/* <Badge dot> */}
        {/* {!location.pathname?.includes('/announcement-feeds') ? <AnnouncementBanner /> : null} */}

        <Avatar
          className="last"
          src={srcImgProfile}
          style={{ color: '#eef2f4', backgroundColor: '#1c99f5' }}
        >
          {currentAdmin?.name.charAt(0).toUpperCase()}
        </Avatar>
      </Dropdown>

      <div
        style={{
          marginTop: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Popover
          content={
            <NotificationComponent
              notifications={notifications}
              setNotifications={setNotifications}
              unreadCount={unreadCount}
              setUnreadCount={setUnreadCount}
              fetchNotifications={fetchNotifications}
              hasFetched={hasFetched}
              isNotificationLoading={isNotificationLoading}
            />
          }
          title="Notifications"
          trigger="click"
        >
          <Badge count={unreadCount > 0 ? unreadCount : 0} overflowCount={99}>
            <Button
              icon={<BellTwoTone twoToneColor="#1890ff" />}
              shape="circle"
            />
          </Badge>
        </Popover>
      </div>
      {/* <Popover content={<InterviewNotifications isNotificaitonLoading={isNotificaitonLoading} setIsNotificaitonLoading={setIsNotificaitonLoading} />} title="Notifications" trigger="click">
          <Button icon={<BellTwoTone />} shape="circle" />
        </Popover> */}
    </div >
  );
}

//  <Avatar icon={<AppstoreOutlined />} />
// <Dropdown overlay={<Notifications />} trigger={['click']} placement="bottomRight">
//   {/* <Badge dot> */}
//   <Avatar icon={<BellOutlined />} />

//   {/* </Badge> */}
// </Dropdown>;
